import { memo, useCallback } from 'react';
import classnames from 'classnames';

export interface CollapseButtonProps {
  isExpanded?: boolean;
  onClick: (value: boolean) => void;
}

const CollapseButton = ({ isExpanded, onClick }) => {
  const handleClick = useCallback(() => {
    onClick(!isExpanded);
  }, [isExpanded, onClick]);

  const iconClassNames = classnames({
    lnr: true,
    'lnr-chevron-right-circle': !isExpanded,
    'lnr-chevron-down-circle': isExpanded,
  });

  return (
    <span className="margin-right">
      <button type="button" className="btn btn-box-tool btn-sm no-padding text-dark-blue" onClick={handleClick}>
        <i className={iconClassNames} />
      </button>
    </span>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(CollapseButton);
